function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatPrice = (min, max) => {
  if (min === max) return `$${numberWithCommas(min)}`;
  return `$${numberWithCommas(Math.floor(min))} - $${numberWithCommas(
    Math.floor(max)
  )}`;
};
